import { Provider } from '@angular/core';
import { InMemoryStorage, StorageService } from './storage.service';
import { LOCAL_STORAGE, SESSION_STORAGE } from './storage.tokens';

export function resolveBackend(preferred: () => Storage): Storage {
  try {
    const storage = preferred();
    const probeKey = '__shiftat_storage_probe__';
    storage.setItem(probeKey, '1');
    storage.removeItem(probeKey);
    return storage;
  } catch {
    console.warn('[storage] backend unavailable; falling back to in-memory');
    return new InMemoryStorage();
  }
}

export function provideStorage(): Provider[] {
  return [
    {
      provide: LOCAL_STORAGE,
      useFactory: () =>
        new StorageService(
          resolveBackend(() => localStorage),
          'local',
        ),
    },
    {
      provide: SESSION_STORAGE,
      useFactory: () =>
        new StorageService(
          resolveBackend(() => sessionStorage),
          'session',
        ),
    },
  ];
}
